import { Routes, Route, useLocation, Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import appStyles from 'app/providers/theme/App.module.css';
import { useEffect } from 'react';
import { RoutesType } from 'shared/types/routes/routers-type';
import { colors } from 'app/providers/theme/colors-type';
import { MainPage } from 'pages/main-page/MainPage';
import { MitePolicy } from 'pages/mite-policy/MitePolicy';
import FeedbackMobApp from 'pages/feedback-mob-app/FeedbackMobApp';
import { CancerProtection } from 'pages/cancer-protection/CancerProtection';
import { HealthAI } from 'pages/health-ai/HealthAI';
import FeedbackMaxBot from 'pages/feedback-max-bot/FeedbackMaxBot';


const AppLayout: React.FC = () => {

  return (
    <>
      <Box className={appStyles.appContainer}>
        <Box className={appStyles.content}>
          <Outlet />
        </Box>
      </Box>
    </>
  );
};

const AppRouter: React.FC = () => {
  return (
    <Routes>
      <Route element={<AppLayout />}>
        <Route path={RoutesType.Main} element={<MainPage />} />
        <Route path={RoutesType.MitePolicy} element={<MitePolicy />} />
        <Route path={RoutesType.CancerProtection} element={<CancerProtection />} />
        <Route path={RoutesType.HealthAL} element={<HealthAI />} />
        <Route path={RoutesType.Feedback} element={<FeedbackMobApp />} />
        
        <Route path={RoutesType.FeedbackMaxBot} element={<FeedbackMaxBot />} />
      </Route>

    </Routes>
  );
};

export default AppRouter;
